export interface Video {
    id: string;
    title: string;
    vimeoId: string;
    duration: string;
    description: string;
    isCompleted?: boolean;
    instructionsPath?: string; // Path to HTML file in public/lessons folder
}

// Course video data - maps course IDs to their lesson videos
export const courseVideos: { [courseId: string]: Video[] } = {
    'playwright-k17': [
        {
            id: 'k17-day1',
            title: 'K17 - DAY 01',
            vimeoId: '1130377168',
            duration: '95:30',
            description: `
      Setup Node env and basic about programming language
      https://nodejs.org/en/download
      https://code.visualstudio.com/Download
      `,
        },
        {
            id: 'k17-day2',
            title: 'K17 - DAY 02',
            vimeoId: '1130377202',
            duration: '102:15',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day3',
            title: 'K17 - DAY 03',
            vimeoId: '1130377234',
            duration: '98:45',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day4',
            title: 'K17 - DAY 04',
            vimeoId: '1130377269',
            duration: '101:20',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day5',
            title: 'K17 - DAY 05',
            vimeoId: '1130377292',
            duration: '95:10',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day6',
            title: 'K17 - DAY 06',
            vimeoId: '1130377327',
            duration: '102:30',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day7',
            title: 'K17 - DAY 07',
            vimeoId: '1130377355',
            duration: '98:15',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day8',
            title: 'K17 - DAY 08',
            vimeoId: '1130377382',
            duration: '104:20',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day9',
            title: 'K17 - DAY 09',
            vimeoId: '1130377410',
            duration: '101:45',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day10',
            title: 'K17 - DAY 10',
            vimeoId: '1130377434',
            duration: '99:30',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day11',
            title: 'K17 - DAY 11',
            vimeoId: '1130377452',
            duration: '103:15',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day12',
            title: 'K17 - DAY 12',
            vimeoId: '1130377466',
            duration: '96:45',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day13',
            title: 'K17 - DAY 13',
            vimeoId: '1130377489',
            duration: '100:20',
            description: `
      https://github.com/sdetpro-blog/nodejs-exercises
      `
        },
        {
            id: 'k17-day14',
            title: 'K17 - DAY 14',
            vimeoId: '1130377509',
            duration: '105:10',
            description: '...'
        },
        {
            id: 'k17-day15',
            title: 'K17 - DAY 15',
            vimeoId: '1130377524',
            duration: '102:35',
            description: '...'
        },
        {
            id: 'k17-day16',
            title: 'K17 - DAY 16',
            vimeoId: '1130377553',
            duration: '98:50',
            description: '...'
        },
        {
            id: 'k17-day17',
            title: 'K17 - DAY 17',
            vimeoId: '1130377575',
            duration: '101:25',
            description: '...'
        },
        {
            id: 'k17-day18',
            title: 'K17 - DAY 18',
            vimeoId: '1130377589',
            duration: '97:40',
            description: '...'
        },
        {
            id: 'k17-day19',
            title: 'K17 - DAY 19',
            vimeoId: '1130377605',
            duration: '99:55',
            description: '...'
        },
        {
            id: 'k17-day20',
            title: 'K17 - DAY 20',
            vimeoId: '1130377624',
            duration: '104:30',
            description: '...'
        },
        {
            id: 'k17-day21',
            title: 'K17 - DAY 21',
            vimeoId: '1130377641',
            duration: '102:15',
            description: '...'
        },
        {
            id: 'k17-day22',
            title: 'K17 - DAY 22',
            vimeoId: '1130377650',
            duration: '100:45',
            description: '...'
        },
        {
            id: 'k17-day23',
            title: 'K17 - DAY 23',
            vimeoId: '1130377662',
            duration: '103:20',
            description: '...'
        },
        {
            id: 'k17-day24',
            title: 'K17 - DAY 24',
            vimeoId: '1130377677',
            duration: '98:25',
            description: '...'
        },
        {
            id: 'k17-day25',
            title: 'K17 - DAY 25',
            vimeoId: '1130377685',
            duration: '101:10',
            description: '...'
        },
        {
            id: 'k17-day26',
            title: 'K17 - DAY 26',
            vimeoId: '1130377699',
            duration: '96:30',
            description: '...'
        },
        {
            id: 'k17-day27',
            title: 'K17 - DAY 27',
            vimeoId: '1130377716',
            duration: '104:50',
            description: '...'
        },
        {
            id: 'k17-day28',
            title: 'K17 - DAY 28',
            vimeoId: '1130377746',
            duration: '99:20',
            description: '...'
        },
        {
            id: 'k17-day29',
            title: 'K17 - DAY 29',
            vimeoId: '1130377775',
            duration: '106:15',
            description: '...'
        },
        {
            id: 'k17-day30',
            title: 'K17 - DAY 30',
            vimeoId: '1130518172',
            duration: '103:45',
            description: '...'
        },
        {
            id: 'k17-day31',
            title: 'K17 - DAY 31',
            vimeoId: '1131335876',
            duration: '104:20',
            description: '...'
        },
        {
            id: 'k17-day32',
            title: 'K17 - DAY 32',
            vimeoId: '1132211072',
            duration: '100:20',
            description: `
      Handle variant components with IS-A relationship
      Run test against same E2E flow with different component variants
      `
        },
        {
            id: 'k17-day33',
            title: 'K17 - DAY 33',
            vimeoId: '1133498049',
            duration: '102:17',
            description: `
      Continue E2E flow
      Added buildComputerSpecAndAddToCart for OrderComputerFlow
      Handled variant test data
      `
        },
        {
            id: 'k17-day34',
            title: 'K17 - DAY 34',
            vimeoId: '1134875699',
            duration: '114:27',
            description: 'Continue E2E flow'
        },
        {
            id: 'k17-day35',
            title: 'K17 - DAY 35',
            vimeoId: '1134876961',
            duration: '90:21',
            description: 'Continue E2E flow'
        },
        {
            id: 'k17-day36',
            title: 'K17 - DAY 36',
            vimeoId: '1135767519',
            duration: '90:01',
            description: 'Continue E2E flow'
        },
        {
            id: 'k17-day37',
            title: 'K17 - DAY 37',
            vimeoId: '1136921840',
            duration: '94:21',
            description: 'Complete E2E flow'
        },
        {
            id: 'k17-day38',
            title: 'K17 - DAY 38',
            vimeoId: '1138106994',
            duration: '86:18',
            description: 'Configure Reporters'
        },
        {
            id: 'k17-day39',
            title: 'K17 - DAY 39',
            vimeoId: '1139649473',
            duration: '02:30:16',
            description: 'Parallel Execution and Jenkins Integration'
        }
    ],
    'complete-test-system': [
        {
            id: 'intro',
            title: 'AI-POWERED Test Assistant | INTRO',
            vimeoId: '1139077612',
            duration: '05:48',
            description: ``,
        },
        {
            id: 'test-system-course-day1',
            title: 'LESSON 01',
            vimeoId: '1135607764',
            duration: '19:29',
            description: `
      Prepare development environment
      Install Node and IDE (VS Code)
      `,
        },
        {
            id: 'test-system-course-day2',
            title: 'LESSON 02',
            vimeoId: '1137553644',
            duration: '25:02',
            description: `
      Initialize frontend project
      Install dependencies
      `,
            instructionsPath: 'LESSON_01.HTML'
        },
        {
            id: 'test-system-course-day3',
            title: 'LESSON 03',
            vimeoId: '1137553701',
            duration: '13:19',
            description: `
      Initialize backend project
      Install dependencies
      `,
            instructionsPath: 'LESSON_01.HTML'
        },
        {
            id: 'test-system-course-day4',
            title: 'LESSON 04',
            vimeoId: '1137553724',
            duration: '01:10:21',
            description: 'Frontend: Build Login Form',
            instructionsPath: 'LESSON_LOGIN_FORM.HTML'
        },
        {
            id: 'test-system-course-day5',
            title: 'LESSON 05',
            vimeoId: '1137553926',
            duration: '41:43',
            description: 'Frontend: Build Register Form',
            instructionsPath: 'LESSON_REGISTER_FORM.HTML'
        },
        {
            id: 'test-system-course-day6',
            title: 'LESSON 06',
            vimeoId: '1137554071',
            duration: '28:18',
            description: 'Frontend: Build Generate Page',
            instructionsPath: 'GENERATE_PAGE.HTML'
        },
        {
            id: 'test-system-course-day7',
            title: 'LESSON 07',
            vimeoId: '1137554155',
            duration: '07:27',
            description: 'Frontend: Build Generate Page',
            instructionsPath: 'DASHBOARD_PAGE.HTML'
        },
        {
            id: 'test-system-course-day8',
            title: 'LESSON 08',
            vimeoId: '1137554182',
            duration: '48:11',
            description: 'Frontend: Build Wrapper Layout',
            instructionsPath: 'LAYOUT.HTML'
        },
        {
            id: 'test-system-course-day9',
            title: 'LESSON 09',
            vimeoId: '1137554341',
            duration: '07:48',
            description: 'Frontend: Build wrapper for private route'
        },
        {
            id: 'test-system-course-day10',
            title: 'LESSON 10',
            vimeoId: '1137554382',
            duration: '11:55',
            description: 'Database: Create and setup MongoDB Cloud'
        },
        {
            id: 'test-system-course-day11',
            title: 'LESSON 11',
            vimeoId: '1137554421',
            duration: '01:32:29',
            description: 'Backend: User Register Flow',
            instructionsPath: 'REGISTER_USER_FLOW.HTML'
        },
        {
            id: 'test-system-course-day12',
            title: 'LESSON 12',
            vimeoId: '1137554717',
            duration: '21:50',
            description: 'Frontend: State Management with Zustand',
            instructionsPath: 'AUTH_STATE_STORE.HTML'
        },
        {
            id: 'test-system-course-day13',
            title: 'LESSON 13',
            vimeoId: '1137554791',
            duration: '19:58',
            description: 'Frontend: API Utility',
            instructionsPath: 'FRONTEND_API_UTIL.HTML'
        },
        {
            id: 'test-system-course-day14',
            title: 'LESSON 14',
            vimeoId: '1137554858',
            duration: '38:57',
            description: 'Frontend, Backend, DB: Complete Register Flow',
            instructionsPath: 'REGISTER_FLOW_HOOK_UP_FRONT_END.HTML'
        },
        {
            id: 'test-system-course-day15',
            title: 'LESSON 15',
            vimeoId: '1137555008',
            duration: '38:55',
            description: 'Frontend, Backend, DB: Complete Login Flow',
            instructionsPath: 'COMPLETE_LOGIN_FLOW.HTML'
        },
        {
            id: 'test-system-course-day16',
            title: 'LESSON 16',
            vimeoId: '1137555135',
            duration: '10:59',
            description: 'Prepare Atlassian and openAI account'
        },
        {
            id: 'test-system-course-day17',
            title: 'LESSON 17',
            vimeoId: '1137555168',
            duration: '07:08',
            description: 'Add API keys into Configuration Files'
        },
        {
            id: 'test-system-course-day18',
            title: 'LESSON 18',
            vimeoId: '1137555197',
            duration: '20:28',
            description: 'Complete Logout Feature'
        },
        {
            id: 'test-system-course-day19',
            title: 'LESSON 19',
            vimeoId: '1137555268',
            duration: '39:19',
            description: 'Analyze Ticket Feature - Create JIRA Service Layer',
            instructionsPath: 'ANALYZE_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day20',
            title: 'LESSON 20',
            vimeoId: '1137555336',
            duration: '55:00',
            description: 'Analyze Ticket Feature - requireAuth middleware and preflight API',
            instructionsPath: 'ANALYZE_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day21',
            title: 'LESSON 21',
            vimeoId: '1137555360',
            duration: '02:43',
            description: 'Add watch command for backend'
        },
        {
            id: 'test-system-course-day22',
            title: 'LESSON 22',
            vimeoId: '1137555370',
            duration: '01:53:32',
            description: 'Analyze Ticket Feature - preflight api, generation model and UI display',
            instructionsPath: 'ANALYZE_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day23',
            title: 'LESSON 23',
            vimeoId: '1137555404',
            duration: '40:35',
            description: 'Generation Feature: Create OpenAI service layer',
            instructionsPath: 'OPENAI_SERVICE.HTML'
        },
        {
            id: 'test-system-course-day24',
            title: 'LESSON 24',
            vimeoId: '1137555416',
            duration: '16:03',
            description: 'Generation feature - Project Schema and Project utility'
        },
        {
            id: 'test-system-course-day25',
            title: 'LESSON 25',
            vimeoId: '1137555436',
            duration: '43:00',
            description: 'Generation feature - Test Scenario Generation API',
            instructionsPath: 'TEST_SCENARIO_GENERATION_API.HTML'
        },
        {
            id: 'test-system-course-day25-cont',
            title: 'LESSON 25 (cont.)',
            vimeoId: '1137555451',
            duration: '02:04',
            description: 'Generation feature - fix some bugs!!'
        },
        {
            id: 'test-system-course-day26',
            title: 'LESSON 26',
            vimeoId: '1137555458',
            duration: '08:50',
            description: 'Generation feature - Verify Test Scenario Generation API'
        },
        {
            id: 'test-system-course-day27',
            title: 'LESSON 27',
            vimeoId: '1137555466',
            duration: '26:13',
            description: 'Generation feature - Add link to generate page to the view generated scenarios',
            instructionsPath: 'VIEWPAGE_DISPLAYING_GENERATION_CONTENT.HTML'
        },
        {
            id: 'test-system-course-day28',
            title: 'LESSON 28',
            vimeoId: '1137555479',
            duration: '13:04',
            description: 'Generation feature - Create view endpoint',
            instructionsPath: 'VIEWPAGE_DISPLAYING_GENERATION_CONTENT.HTML'
        },
        {
            id: 'test-system-course-day29',
            title: 'LESSON 29',
            vimeoId: '1137555489',
            duration: '33:08',
            description: 'Generation feature - Create view page content section',
            instructionsPath: 'VIEWPAGE_DISPLAYING_GENERATION_CONTENT.HTML'
        },
        {
            id: 'test-system-course-day30',
            title: 'LESSON 30',
            vimeoId: '1137555503',
            duration: '31:41',
            description: 'View page header UI and metadata',
            instructionsPath: 'VIEWPAGE_HEADER_COMPONENT_AND_META_DATA.HTML'
        },
        {
            id: 'test-system-course-day31',
            title: 'LESSON 31',
            vimeoId: '1137663499',
            duration: '59:14',
            description: 'View page header , Edit function',
            instructionsPath: 'VIEWPAGE_EDIT_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day32',
            title: 'LESSON 32',
            vimeoId: '1137556809',
            duration: '29:51',
            description: 'View page header , Publish function',
            instructionsPath: 'VIEWPAGE_PUBLISH_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day33',
            title: 'LESSON 33',
            vimeoId: '1137556854',
            duration: '12:28',
            description: 'View page header , Download function',
            instructionsPath: 'VIEWPAGE_DOWNLOAD_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day34',
            title: 'LESSON 34',
            vimeoId: '1137556888',
            duration: '21:27',
            description: 'View page header , Delete function',
            instructionsPath: 'VIEWPAGE_DELETE_FUNCTION.HTML'
        },
        {
            id: 'test-system-course-day35-prep',
            title: 'LESSON 35 PREPARATION',
            vimeoId: '1138779786',
            duration: '21:19',
            description: 'Dashboard, Learn about HTML Table',
        },
        {
            id: 'test-system-course-day35',
            title: 'LESSON 35',
            vimeoId: '1137556954',
            duration: '21:19',
            description: 'Dashboard, display all generations',
            instructionsPath: 'DASHBOARDPAGE_DISPLAY_ALL_GENERATION.HTML'
        },
        {
            id: 'test-system-course-day36',
            title: 'LESSON 36',
            vimeoId: '1137838995',
            duration: '22:39',
            description: 'Dashboard, Pagination Backend changes',
            instructionsPath: 'DASHBOARDPAGE_GENERATION_PAGINATION.HTML'
        },
        {
            id: 'test-system-course-day37',
            title: 'LESSON 37',
            vimeoId: '1137839037',
            duration: '22:13',
            description: 'Dashboard, Pagination Frontend changes',
            instructionsPath: 'DASHBOARDPAGE_GENERATION_PAGINATION.HTML'
        },
        {
            id: 'test-system-course-day38',
            title: 'LESSON 38',
            vimeoId: '1137839071',
            duration: '05:38',
            description: 'Dashboard, filter generation Backend changes',
            instructionsPath: 'DASHBOARDPAGE_GENERATION_FILTERED_TAB.HTML'
        },
        {
            id: 'test-system-course-day39',
            title: 'LESSON 39',
            vimeoId: '1137839088',
            duration: '13:50',
            description: 'Dashboard, filter generation Frontend changes',
            instructionsPath: 'DASHBOARDPAGE_GENERATION_FILTERED_TAB.HTML'
        },
        {
            id: 'test-system-course-day40',
            title: 'LESSON 40',
            vimeoId: '1146458605',
            duration: '15:45',
            description:
            `Backend, Deploy to Cloud(Vercel)
            Push code to GitHub: <a href="https://docs.google.com/document/d/1A9f7L7jSksxud1d-3Ms2A8b3dCXOXk-sE6TSZ7c0gfs/edit?usp=sharing" target="_blank">https://docs.google.com/document/d/1A9f7L7jSksxud1d-3Ms2A8b3dCXOXk-sE6TSZ7c0gfs/edit?usp=sharing</a>
            `,
        },
        {
            id: 'test-system-course-day41',
            title: 'LESSON 41',
            vimeoId: '1146458984',
            duration: '18:04',
            description: 'Frontend, Deploy to Cloud(Vercel)',
        }
    ],
};

// Helper function to get the intro video for a course
export const getCourseIntroVideo = (courseId: string): Video | null => {
    const videos = courseVideos[courseId];
    if (!videos) return null;

    // Find the video with id 'intro'
    const introVideo = videos.find(video => video.id === 'intro');
    return introVideo || null;
};
